export type UploadResponse = {
  filename: string;
  mimetype: string;
  size: number;
  probe?: {
    width: number;
    height: number;
    mimeType: string;
  };
};

const uploadFile = async (
  file: File,
  endpointUrl: string,
  onProgress?: (progress: number) => void
): Promise<UploadResponse> =>
  new Promise<UploadResponse>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const formData = new FormData();

    formData.append("file", file);

    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable && onProgress) {
        const progress = (event.loaded / event.total) * 100;
        onProgress(progress);
      }
    });

    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(JSON.parse(xhr.response as string) as UploadResponse);
      } else {
        reject(new Error(`Upload failed with status ${xhr.status}`));
      }
    });

    xhr.addEventListener("error", () => {
      reject(new Error("Upload failed"));
    });

    xhr.addEventListener("abort", () => {
      reject(new Error("Upload aborted"));
    });

    xhr.open("POST", endpointUrl);
    xhr.withCredentials = true;
    xhr.send(formData);
  });

export default uploadFile;

export const uploadFileViaFetch = async (file: File, endpointUrl: string) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(endpointUrl, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Upload failed with status ${response.status}`);
  }

  return response.json() as Promise<UploadResponse>;
};
